var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterMapDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25H0.75V0.75H5.25V2.25H2.25V5.25Z",
    fill: "#C2C7D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.17 4.515L13.25 4.5C13.39 4.5 13.5 4.61 13.5 4.75V12.31C13.5 12.425 13.425 12.515 13.32 12.55L10.5 13.5L7.5 12.45L4.83 13.485L4.75 13.5C4.61 13.5 4.5 13.39 4.5 13.25V5.69C4.5 5.575 4.575 5.485 4.68 5.45L7.5 4.5L10.5 5.55L13.17 4.515ZM12 11.4108L10.5093 11.913L10.5 11.9098V7.13822L10.5265 7.14749L12 6.57629V11.4108ZM9.75 6.87572L8.25 6.35072V11.1223L9.75 11.6473V6.87572ZM7.5 6.08822V10.8598L7.47352 10.8505L6 11.4217V6.58714L7.49069 6.08496L7.5 6.08822Z",
    fill: "#C2C7D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75H0.75V17.25H5.25V15.75H2.25V12.75Z",
    fill: "#C2C7D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.75V17.25H17.25V12.75H15.75V15.75H12.75Z",
    fill: "#C2C7D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.25V0.75H17.25V5.25H15.75V2.25H12.75Z",
    fill: "#C2C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterMapDisableIcon);
export default __webpack_public_path__ + "static/media/centerMapDisableIcon.f1290c6330ebdcd593a0551707108965.svg";
export { ForwardRef as ReactComponent };